import { reducer as formsReducer } from 'redux-form';
import { combineReducers } from 'redux';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import archives from './reducers/archives';
import companies from './reducers/companies';
import licenses from './reducers/licenses';
import gridStore from './reducers/gridStore';
import session from './reducers/session';
import faqs from './reducers/faqs';
import storage from './reducers/storage';
import tos from './reducers/tos';
import teamMembers from './reducers/teamMembers';
import dataTypes from './reducers/dataTypes';
import compatibility from './reducers/compatibility';

export const history = createHistory();

const locationState = history.location.state;

if (locationState && locationState.activePanel) {
    delete history.location.state.activePanel;
}

export const middleware = routerMiddleware(history);

const createRootReducer = () => combineReducers({
    // it's important that the key is `form`
    form: formsReducer,
    router: routerReducer,
    archives,
    companies,
    licenses,
    gridStore,
    session,
    faqs,
    storage,
    teamMembers,
    tos,
    dataTypes,
    compatibility,
});

export default createRootReducer;



// WEBPACK FOOTER //
// ./src/store/createRootReducer.js